module.exports = function getResource(label, vars = []) {
    const resources = { new: 'Nouveauté' };
    return resources[label];
};
